<template>
    <div class="html-editor">
        <div :id="id" ref="editor" class="editor-content" role="textbox" aria-multiline="true" :aria-label="ariaLabel" :style="{ minHeight }"></div>
    </div>
</template>

<script>
import Quill from 'quill'

const Delta = Quill.import('delta')

export default {
    name: 'HtmlEditor',

    props: {
        id: {
            type: String,
            default: null,
        },
        modelValue: {
            type: String,
            default: ''
        },
        toolbar: {
            type: Array,
            default: () => [
                ['bold', 'italic', 'underline', 'strike', 'link'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                ['clean'],
            ]
        },
        placeholder: {
            type: String,
            default: '',
        },
        ariaLabel: {
            type: String,
            default: 'Редактор текста',
        },
        minHeight: {
            type: String,
            default: '250px',
        }
    },

    emits: ['update:modelValue'],

    data() {
        return {
            quill: null,
            isSyncing: false
        }
    },

    mounted() {
        this.$refs.editor.innerHTML = this.modelValue || ''

        this.quill = new Quill(this.$refs.editor, {
            theme: 'snow',
            placeholder: this.placeholder,
            modules: {
                toolbar: this.toolbar,
                clipboard: {
                    matchers: [
                        ['img', () => new Delta()],
                    ],
                },
            },
        })

        this.quill.on('text-change', () => {
            if (this.isSyncing) return

            const html = this.quill.getText().trim() === '' ? '' : this.quill.root.innerHTML
            this.$emit('update:modelValue', html)
        })
    },

    watch: {
        modelValue(val) {
            if (!this.quill) return

            const current = this.quill.root.innerHTML
            if (current === val) return

            this.isSyncing = true
            this.quill.clipboard.dangerouslyPasteHTML(val || '', 'silent')
            this.isSyncing = false
        }
    },
}
</script>

<style scoped>
.html-editor {
    border: none;
}

.editor-toolbar {
    border-bottom: 1px solid #ced4da;
}

</style>
